<template>
        <div>    <ob-modal2  style="overflow: scroll;" :show.sync="show" width="900px" :backdrop="false">
        <template slot="modal-title">
            <div class="modal-head">
                <h4 class="modal-title">
                    {{ isupdate ? 'Update' : 'Initiate' }} Material Change
                </h4>
                
            </div>
        </template>

        <template slot="modal-body">
            <template>
                <div class="row rowgap" v-if="isHRManager">
                    <div class="col-md-12">
                        <p class="title-content">
                            <b class="note-content">Note: Updates will be shared with the student.</b>
                        </p>
                        <p class="title-content" v-if="isupdate !== true">
                            <b class="note-content">A new Form I-983 will be created with this material change. So, please verify and sign the new form.</b>
                        </p>
                    </div>
                </div>
                <div class="row" style="padding-left: 10px;" v-if="!isupdate">
                    <div >
                        <label>Which signature option do you prefer for Form I-983?</label>
                    </div>
                    <div  style="margin-bottom: 10px;">
                        <div class="radio-inline">
                            <ob-radio name="electronicSign" :val="1" v-model="SignatureType">Electronic signature</ob-radio>
                            <span style="font-size: 12px; padding-left: 20px;">Electronically fill out and sign the form within the system.</span>
                        </div>
                    </div>
                    <div  >
                        <div class="radio-inline">
                            <ob-radio name="electronicSign" :val="2" v-model="SignatureType">Ink signature</ob-radio>
                            <span style="font-size: 12px; padding-left: 20px;">Electronically fill out the form, download it, physically sign it with ink, and then upload the signed document into the system.</span>
                        </div>
                    </div>
                    <!-- <div class="modal-body"> -->
                        <span class="ob-vuelidate_error-msg " v-if="$v.SignatureType.$dirty && !$v.SignatureType.requiredIf" style="margin-left: 3em;">Please select signature preference.</span>
                    <!-- </div> -->
                </div>
                
                
              
              
              
                <div class="row" v-if="$parent.IsFinalEvaluationDone">
                    <div class="col-md-12">
                        <p class="rcss-text-warning"><i class="fa fa-warning"></i> Final evaluation is completed for this student. If you have to do material change it has to be prior to the final evaluation.</p>
                    </div>
                </div>
                <div class="row rowgap">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>Select Material Change</label><span class="validation-star">*</span>
                             <ob-select2 :inModal="true" :options="materialChangeOptions" :change="onMaterialChange" :multiple="true" v-model="MaterialChange"  :class="{ 'ob-vuelidate_input-error': $v.MaterialChange.$error }"></ob-select2>
                             <span class="ob-vuelidate_error-msg" v-if="$v.MaterialChange.$dirty && !$v.MaterialChange.required"> Select material change</span>
                        </div>
                    </div>
                </div>
                 <div class="row rowgap">
                        <div class="col-md-12">
                           <b> Provide the information as per the Form I-983's material change</b>
                        </div>
                </div>

                <template v-if="showSpecifyReason">
                    <div class="row rowgap">
                    <div class="col-md-12">
                        <div class="form-group">
                        <label>Specify reason for others</label><span class="validation-star">*</span>
                        <ob-textarea :maxLength="150" v-model.trim="SpecifyReason" placeholder="Enter Specify Reason" :class="{ 'ob-vuelidate_input-error': $v.SpecifyReason.$error }"></ob-textarea>
                        <span class="ob-vuelidate_error-msg" v-if="$v.SpecifyReason.$dirty && !$v.SpecifyReason.requiredIf"> Enter Specify Reason</span>
                        </div>
                    </div>
                    </div>
                </template>

                <template v-if="showChangeOfEID || showPeriodicEvaluationFromTheUniversity">
                    <div class="row rowgap">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>Employer ID Number (EIN)</label><span class="validation-star">*</span>
                                <ob-input v-model.trim="EmployerInfo.EmployerIDNumber" placeholder="Enter Employer ID Number" :class="{ 'ob-vuelidate_input-error': $v.EmployerInfo.EmployerIDNumber.$error }"></ob-input>
                                <span class="ob-vuelidate_error-msg" v-if="$v.EmployerInfo.EmployerIDNumber.$dirty && !$v.EmployerInfo.EmployerIDNumber.requiredIf"> Enter Employer ID Number</span>
                            </div>
                        </div>
                    </div>
                </template>

                 <template v-if="showReductionInComp || showPeriodicEvaluationFromTheUniversity">
                     <div class="row rowgap">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>OPT Hours Per Week</label><span class="validation-star">*</span>
                                <i class="fa fa-info-circle" v-tooltip="'Must be between 20-40 hours/week.'" :class="{ 'ob-vuelidate_input-error': $v.EmployerInfo.OPTHoursPerWeek.$error }"></i>
                                <ob-input  v-number-only :maxLength="10" v-model.trim="EmployerInfo.OPTHoursPerWeek" placeholder="Enter OPT Hours Per Week" :class="{ 'ob-vuelidate_input-error': $v.EmployerInfo.OPTHoursPerWeek.$error }"></ob-input>
                                <span class="ob-vuelidate_error-msg" v-if="$v.EmployerInfo.OPTHoursPerWeek.$dirty && !$v.EmployerInfo.OPTHoursPerWeek.requiredIf"> Enter OPT Hours Per Week</span>
                                <span class="ob-vuelidate_error-msg" v-if="$v.EmployerInfo.OPTHoursPerWeek.$dirty && $v.EmployerInfo.OPTHoursPerWeek.requiredIf && !$v.EmployerInfo.OPTHoursPerWeek.ValidOPTHoursPerWeek">Must be between 20-40 hours/week.</span>
                            </div>
                        </div>
                    </div>

                    <div class="row rowgap">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>Salary Amount</label><span class="validation-star">*</span>
                                <ob-input icon="fa-usd" v-model.trim="EmployerInfo.Salary" v-decimal-numbers placeholder="Salary Amount" :class="{ 'ob-vuelidate_input-error': $v.EmployerInfo.Salary.$error }"></ob-input>
                                <span class="ob-vuelidate_error-msg" v-if="$v.EmployerInfo.Salary.$dirty && !$v.EmployerInfo.Salary.requiredIf"> Enter Salary Amount</span>
                                <span class="ob-vuelidate_error-msg" v-if="$v.EmployerInfo.Salary.$dirty && $v.EmployerInfo.Salary.requiredIf && !$v.EmployerInfo.Salary.ValidSalary">Must be greater than 0.</span>
                            </div>
                        </div>

                         <div class="col-md-4">
                            <div class="form-group">
                                <label>Salary Frequency</label><span class="validation-star">*</span>
                                <ob-select2 :inModal="true" v-model.trim="EmployerInfo.SalaryType" :options="salary" :class="{ 'ob-vuelidate_input-error': $v.EmployerInfo.SalaryType.$error }"></ob-select2>
                                <span class="ob-vuelidate_error-msg" v-if="$v.EmployerInfo.SalaryType.$dirty && !$v.EmployerInfo.SalaryType.ValidSalaryType"> Select Salary Frequency</span>
                            </div>
                        </div>
                    </div>
                </template>

                 <template v-if="showdecreaseinHoursPerWeek && showReductionInComp == false && showPeriodicEvaluationFromTheUniversity == false">
                    <div class="row rowgap">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>OPT Hours Per Week</label><span class="validation-star">*</span>
                                <ob-input   v-number-only :maxLength="10" v-model.trim="EmployerInfo.OPTHoursPerWeek" placeholder="Enter OPT Hours Per Week" :class="{ 'ob-vuelidate_input-error': $v.EmployerInfo.OPTHoursPerWeek.$error }"></ob-input>
                                <span class="ob-vuelidate_error-msg" v-if="$v.EmployerInfo.OPTHoursPerWeek.$dirty && !$v.EmployerInfo.OPTHoursPerWeek.requiredIf"> Enter OPT Hours Per Week</span>
                                 <span class="ob-vuelidate_error-msg" v-if="$v.EmployerInfo.OPTHoursPerWeek.$dirty && $v.EmployerInfo.OPTHoursPerWeek.requiredIf && !$v.EmployerInfo.OPTHoursPerWeek.ValidOPTHoursPerWeek">Must be between 20-40 hours/week.</span>
                            </div>
                        </div>
                    </div>
                </template>
                 <template v-if="showChangeInEmployerSite || showSpecifyReason">
                    <div class="row rowgap">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>Site Name</label><span class="validation-star">*</span>
                                <ob-input v-model.trim="Employer.SignatoryAuthority.SiteName" placeholder="Enter Site Name" :class="{ 'ob-vuelidate_input-error': $v.Employer.SignatoryAuthority.SiteName.$error }"></ob-input>
                                <span class="ob-vuelidate_error-msg" v-if="$v.Employer.SignatoryAuthority.SiteName.$dirty && !$v.Employer.SignatoryAuthority.SiteName.requiredIf">Enter Site Name</span>
                                <span class="ob-vuelidate_error-msg" v-if="$v.Employer.SignatoryAuthority.SiteName.$dirty && !$v.Employer.SignatoryAuthority.SiteName.maxLength && $v.Employer.SignatoryAuthority.SiteName.alpha">Enter 150 characters only</span>
                                <span class="ob-vuelidate_error-msg" v-if="$v.Employer.SignatoryAuthority.SiteName.$dirty &&  $v.Employer.SignatoryAuthority.SiteName.alpha && !$v.Employer.SignatoryAuthority.SiteName.letterCount">Each word can have a maximum of 100 characters only.</span>
                            </div>
                        </div>
                        <div class="col-md-8">
                            <div class="form-group">
                                <label>Site Address (Street, City, State, ZIP)</label><span class="validation-star">*</span>
                                <ob-input v-model.trim="Employer.SignatoryAuthority.SiteAddress" placeholder="Enter Site Address (Street, City, State, ZIP)" :class="{ 'ob-vuelidate_input-error': $v.Employer.SignatoryAuthority.SiteAddress.$error }"></ob-input>
                                <span class="ob-vuelidate_error-msg" v-if="$v.Employer.SignatoryAuthority.SiteAddress.$dirty && !$v.Employer.SignatoryAuthority.SiteAddress.requiredIf">Enter Site Address</span>
                                <span class="ob-vuelidate_error-msg" v-if="$v.Employer.SignatoryAuthority.SiteAddress.$dirty && !$v.Employer.SignatoryAuthority.SiteAddress.maxLength && $v.Employer.SignatoryAuthority.SiteAddress.alpha">Enter 150 characters only</span>
                                <span class="ob-vuelidate_error-msg" v-if="$v.Employer.SignatoryAuthority.SiteAddress.$dirty &&  $v.Employer.SignatoryAuthority.SiteAddress.alpha && !$v.Employer.SignatoryAuthority.SiteAddress.letterCount">Each word can have a maximum of 100 characters only.</span>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-if="showChangetoTheEmployeeComm || showPeriodicEvaluationFromTheUniversity">
                 <div class="row rowgap">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>Training Plan Title</label><span class="validation-star">*</span>
                           <ob-input v-model.trim="StudentDetails.TrainingPlan.Title" placeholder="Enter Training Plan Title" :class="{ 'ob-vuelidate_input-error': $v.StudentDetails.TrainingPlan.Title.$error }"></ob-input>
                            <span class="ob-vuelidate_error-msg" v-if="$v.StudentDetails.TrainingPlan.Title.$dirty && !$v.StudentDetails.TrainingPlan.Title.requiredIf"> Enter Training Plan Title</span>
                        </div>
                    </div>
                </div>
                 <div class="row rowgap">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>Student Role: Describe the student's role with the employer and how that role is directly related to enhancing the student's knowledge
                                    obtained through his or her qualifying STEM degree.</label>
                             <ob-textarea  v-model.trim="StudentDetails.TrainingPlan.StudentRole" placeholder="Enter student roles"></ob-textarea>
                        </div>
                    </div>
                </div>
                <div class="row rowgap">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>Goals and Objectives: Describe how the assignment(s) with the employer will help the student achieve his or her specific objectives for workbased learning related to his or her STEM degree. The description must both specify the student's goals regarding specific knowledge, skills,
                                    or techniques as well as the means by which they will be achieved.</label>
                             <ob-textarea  v-model.trim="StudentDetails.TrainingPlan.GoalsAndObjectives" placeholder="Enter Goals and Objectives"></ob-textarea>
                        </div>
                    </div>
                </div>
                <div class="row rowgap">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>Employer Oversight: Explain how the employer provides oversight and supervision of individuals filling positions such as that being filled by
                                the named F-1 student. If the employer has a training program or related policy in place that controls such oversight and supervision, please
                                describe.</label>
                             <ob-textarea  v-model.trim="StudentDetails.TrainingPlan.EmployerOversight" placeholder="Enter Employer Oversight"></ob-textarea>
                        </div>
                    </div>
                </div>
                  <div class="row rowgap">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>Measures and Assessments: Explain how the employer measures and confirms whether individuals filling positions such as that being filled
                                    by the named F-1 student are acquiring new knowledge and skills. If the employer has a training program or related policy in place that
                                    controls such measures and assessments, please describe.</label>
                             <ob-textarea  v-model.trim="StudentDetails.TrainingPlan.MeasuresAndAssessments" placeholder="Enter Measures and Assessments"></ob-textarea>
                        </div>
                    </div>
                </div>
                 <div class="row rowgap">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>Additional Remarks (optional): Provide additional information pertinent to the Plan.</label>
                             <ob-textarea  v-model.trim="StudentDetails.TrainingPlan.Remarks" placeholder="Enter Additional Remarks"></ob-textarea>
                        </div>
                    </div>
                </div>
            </template>

                <template v-if="!isupdate && show">
                    <div class="row rowgap"  style="border-top: 1.5px dashed #d4cccc;margin-top: 15px; padding-top: 15px;">
                        <b class="col-md-12" style="padding-bottom:15px">Choose your preferred option to initiate material change<span class="validation-star">*</span></b>
                        <div class="col-md-6">
                            <ob-radio name="I983FormType"  :val="true" v-model="IsInitiateOnlySectionType"><b>Initiate Material Change Only</b></ob-radio>
                            <p style="padding-left: 20px;">Creates only material change section (Employer information - section 3 & 4)</p>
                        </div>
                        <div class="col-md-6">
                            <ob-radio name="I983FormType"  :val="false" v-model="IsInitiateOnlySectionType"><b>Initiate New Form I-983</b></ob-radio>
                            <p style="padding-left: 20px;">Creates a new Form I-983 by auto-populating all the data from the existing one.</p>
                        </div>
                         <!-- intiate new form i983  dropdown -->
                         <div >
                            <div class="row">
                            <div class="col-md-12" v-if="ShowEmployerSADropdownBasedOnMaterialChange">
                                <h3 style="font-weight: 600; color: #000;padding:inherit;">Who should review and sign the Employer Information (Section 3 & 4) ?</h3>
                            </div>
                            </div>
                        </div>
                        <div class="row rowgap" v-if="((!isupdate && ShowEmployerSADropdownBasedOnMaterialChange))"  style="margin-top: 5px !important;">
                            <div class="col-md-12">
                            <div class="col-md-5">
                                <div class="form-group">
                                    <label>Employer Official with Signatory Authority</label> <span class="validation-star">*</span><i class="fa fa-info-circle" v-tooltip="'You can Select from Signatory Authorities,HR Managers, or Supervisors.'"></i>
                                    <ob-select2 v-if="showSA" :inModal="true" :disabled="isSupervisor == false" :options="signatoryauthorityList" v-model.trim="selectedSignatoryAuthority"  :class="{ 'ob-vuelidate_input-error': $v.selectedSignatoryAuthority.$error }"></ob-select2>
                                    <span style="display: block;" v-else>Loading....</span>
                                    <span class="ob-vuelidate_error-msg" v-if="$v.selectedSignatoryAuthority.$dirty && !$v.selectedSignatoryAuthority.requiredIf">Enter Employer Official with Signatory Authority</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row rowgap" style="margin-top: 5px !important;"  v-if="!isupdate && ShowEmployerSADropdownBasedOnMaterialChange && IsInitiate">
                        <div class="col-md-12">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>Name of Official</label><span class="validation-star">*</span>
                                    <ob-input :disabled="true" v-formi9-name v-model.trim="Employer.SignatoryAuthority.Name" placeholder="Enter Name of Official" :class="{ 'ob-vuelidate_input-error': $v.Employer.SignatoryAuthority.Name.$error }"></ob-input>
                                    <span class="ob-vuelidate_error-msg" v-if="$v.Employer.SignatoryAuthority.Name.$dirty && !$v.Employer.SignatoryAuthority.Name.requiredIf">Enter Name of Official</span>
                                    <span class="ob-vuelidate_error-msg" v-if="$v.Employer.SignatoryAuthority.Name.$dirty && !$v.Employer.SignatoryAuthority.Name.maxLength && $v.Employer.SignatoryAuthority.Name.alpha">Enter 150 characters only</span>
                                    <span class="ob-vuelidate_error-msg" v-if="$v.Employer.SignatoryAuthority.Name.$dirty &&  $v.Employer.SignatoryAuthority.Name.alpha && !$v.Employer.SignatoryAuthority.Name.letterCount">Each word can have a maximum of 100 characters only.</span>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>Official's Title</label><span class="validation-star">*</span>
                                    <ob-input :disabled="true" v-model.trim="Employer.SignatoryAuthority.Title" placeholder="Enter Official's Title" :class="{ 'ob-vuelidate_input-error': $v.Employer.SignatoryAuthority.Title.$error }"></ob-input>
                                    <span class="ob-vuelidate_error-msg" v-if="$v.Employer.SignatoryAuthority.Title.$dirty && !$v.Employer.SignatoryAuthority.Title.requiredIf">Enter Official's Title</span>
                                    <span class="ob-vuelidate_error-msg" v-if="$v.Employer.SignatoryAuthority.Title.$dirty && !$v.Employer.SignatoryAuthority.Title.maxLength && $v.Employer.SignatoryAuthority.Title.alpha">Enter 150 characters only</span>
                                    <span class="ob-vuelidate_error-msg" v-if="$v.Employer.SignatoryAuthority.Title.$dirty &&  $v.Employer.SignatoryAuthority.Title.alpha && !$v.Employer.SignatoryAuthority.Title.letterCount">Each word can have a maximum of 100 characters only.</span>
                                </div>
                            </div>
                            <div class="col-md-3 ">
                                <div class="form-group">
                                    <label>Official's Email</label><span class="validation-star">*</span>
                                    <ob-input :disabled="true" v-model.trim="Employer.SignatoryAuthority.Email" placeholder="Enter Official's Email" :class="{ 'ob-vuelidate_input-error': $v.Employer.SignatoryAuthority.Email.$error }"></ob-input>
                                    <template v-if="$v.Employer.SignatoryAuthority.Email.$dirty">
                                        <span class="ob-vuelidate_error-msg" v-if="!$v.Employer.SignatoryAuthority.Email.requiredIf">Enter Official's Email</span>
                                        <span class="ob-vuelidate_error-msg" v-else-if="!$v.Employer.SignatoryAuthority.Email.email">Enter valid email</span>
                                    </template>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>Official's Phone Number</label><span class="validation-star">*</span>
                                    <ob-input v-phone-number v-model.trim="Employer.SignatoryAuthority.Phone" placeholder="Enter Official's Phone Number" :class="{ 'ob-vuelidate_input-error': $v.Employer.SignatoryAuthority.Phone.$error }"></ob-input>
                                    <span class="ob-vuelidate_error-msg" v-if="$v.Employer.SignatoryAuthority.Phone.$dirty && !$v.Employer.SignatoryAuthority.Phone.requiredIf">Enter Phone Number</span>
                                    <span class="ob-vuelidate_error-msg" v-if="$v.Employer.SignatoryAuthority.Phone.$dirty && !$v.Employer.SignatoryAuthority.Phone.phoneNumber && $v.Employer.SignatoryAuthority.Phone.requiredIf">Enter valid Phone Number</span>
                                </div>
                            </div>
                        </div> 
                    </div>
                </div>
                <div v-if="!IsInitiateOnlySectionType || ShowTrainingPlanSADropdownBasedOnMaterialChange && IsInitiate" style="margin-top: 0px !important; padding-left: 0px;"  >
                    <div class="row">
                      <div class="col-md-12">
                        <h3 style="font-weight: 600; color: #000 ;">Who should review and sign the Training Plan for STEM OPT students( Sections 5 & 6)?</h3>
                      </div>
                    </div>
                    <div class="row rowgap" >
                        <div >
                            <div class="col-md-5">
                                <div class="form-group">
                                    <label>Employer Official with Signatory Authority</label> <span class="validation-star">*</span><i class="fa fa-info-circle" v-tooltip="'You can Select from Signatory Authorities,HR Managers, or Supervisors.'"></i>
                                    <ob-select2 :disabled="isSupervisor == false" :inModal="true" v-if="showSignatoryauthorityList" :options="signatoryauthorityList" v-model.trim="trainingPlanSelectedSignatoryAuthorityEmail"  :class="{ 'ob-vuelidate_input-error': $v.trainingPlanSelectedSignatoryAuthorityEmail.$error }"></ob-select2>
                                    <!-- <ob-select2 v-if="showSignatoryauthorityList" :options="signatoryauthorityList" v-model.trim="selectedSignatoryAuthority"  :class="{ 'ob-vuelidate_input-error': $v.selectedSignatoryAuthority.$error }"></ob-select2> -->
                    
                                    <span style="display: block;" v-else>Loading....</span>
                                    <span class="ob-vuelidate_error-msg" v-if="$v.trainingPlanSelectedSignatoryAuthorityEmail.$dirty && !$v.trainingPlanSelectedSignatoryAuthorityEmail.requiredIf">Enter Employer Official with Signatory Authority</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row rowgap">
                        <div> 
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>Name of Official</label><span class="validation-star">*</span>
                                    <ob-input :disabled="true" v-formi9-name v-model.trim="AssignedTraining.SignatoryAuthority.Name" placeholder="Enter Name of Official"  :class="{ 'ob-vuelidate_input-error': $v.AssignedTraining.SignatoryAuthority.Name.$error }"></ob-input>
                                    <span class="ob-vuelidate_error-msg" v-if="$v.AssignedTraining.SignatoryAuthority.Name.$dirty && !$v.AssignedTraining.SignatoryAuthority.Name.requiredIf">Enter Name of Official</span>
                                    <!-- <span class="ob-vuelidate_error-msg" v-if="$v.AssignedTraining.SignatoryAuthority.Name.$dirty && !$v.AssignedTraining.SignatoryAuthority.Name.alphawithspace">Enter alphabets only</span> -->
                                    <span class="ob-vuelidate_error-msg" v-if="$v.AssignedTraining.SignatoryAuthority.Name.$dirty && !$v.AssignedTraining.SignatoryAuthority.Name.maxLength && $v.AssignedTraining.SignatoryAuthority.Name.alpha">Enter 150 characters only</span>
                                    <span class="ob-vuelidate_error-msg" v-if="$v.AssignedTraining.SignatoryAuthority.Name.$dirty &&  $v.AssignedTraining.SignatoryAuthority.Name.alpha && !$v.AssignedTraining.SignatoryAuthority.Name.letterCount">Each word can have a maximum of 100 characters only.</span>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>Official's Title</label><span class="validation-star">*</span>
                                    <ob-input :disabled="true" v-model.trim="AssignedTraining.SignatoryAuthority.Title" placeholder="Enter Official's Title"  :class="{ 'ob-vuelidate_input-error': $v.AssignedTraining.SignatoryAuthority.Title.$error }"></ob-input>
                                    <span class="ob-vuelidate_error-msg" v-if="$v.AssignedTraining.SignatoryAuthority.Title.$dirty && !$v.AssignedTraining.SignatoryAuthority.Title.requiredIf">Enter Official's Title</span>
                                    <span class="ob-vuelidate_error-msg" v-if="$v.AssignedTraining.SignatoryAuthority.Title.$dirty && !$v.AssignedTraining.SignatoryAuthority.Title.maxLength && $v.AssignedTraining.SignatoryAuthority.Title.alpha">Enter 150 characters only</span>
                                    <span class="ob-vuelidate_error-msg" v-if="$v.AssignedTraining.SignatoryAuthority.Title.$dirty &&  $v.AssignedTraining.SignatoryAuthority.Title.alpha && !$v.AssignedTraining.SignatoryAuthority.Title.letterCount">Each word can have a maximum of 100 characters only.</span>
                                </div>
                            </div>
                       
                        <div class="col-md-3">
                        <div class="form-group">
                        <label>Official's Email</label><span class="validation-star">*</span>
                        <ob-input :disabled="true" v-model.trim="AssignedTraining.SignatoryAuthority.Email" placeholder="Enter Official's Email"  :class="{ 'ob-vuelidate_input-error': $v.AssignedTraining.SignatoryAuthority.Email.$error }" ></ob-input>
                        <template v-if="$v.AssignedTraining.SignatoryAuthority.Email.$dirty">
                            <span class="ob-vuelidate_error-msg" v-if="!$v.AssignedTraining.SignatoryAuthority.Email.requiredIf">Enter Official's Email</span>
                            <span class="ob-vuelidate_error-msg" v-else-if="!$v.AssignedTraining.SignatoryAuthority.Email.email">Enter valid email</span>
                        </template>
                    </div>
                </div> 
                    <div class="col-md-3">
                        <div class="form-group">
                            <label>Official's Phone Number</label><span class="validation-star">*</span>
                            <ob-input v-phone-number v-model.trim="AssignedTraining.SignatoryAuthority.Phone" placeholder="Enter Official's Phone Number"  :class="{ 'ob-vuelidate_input-error': $v.AssignedTraining.SignatoryAuthority.Phone.$error }"></ob-input>
                            <span class="ob-vuelidate_error-msg" v-if="$v.AssignedTraining.SignatoryAuthority.Phone.$dirty && !$v.AssignedTraining.SignatoryAuthority.Phone.requiredIf">Enter Phone Number</span>
                            <span class="ob-vuelidate_error-msg" v-if="$v.AssignedTraining.SignatoryAuthority.Phone.$dirty && !$v.AssignedTraining.SignatoryAuthority.Phone.phoneNumber && $v.AssignedTraining.SignatoryAuthority.Phone.required">Enter valid Phone Number</span>                            
                        </div>
                        </div>
                  </div>
                </div>
            <div>
                <div class="note mt-3" v-if="!IsInitiateOnlySectionType ">
                    <p class="text-info">
                    Note: An email will be sent to <strong>{{Employer.SignatoryAuthority.Email }}</strong> to review and sign Sections 5 & 6 once the employee reviews the training plan.
                    </p>
                </div>
            </div> 
            </div>
            </template>
            </template>
        </template>
        <template slot="modal-footer" class="modal-footer">
             <ob-button type="secondary" @click="handleCancel">Cancel</ob-button>
                   <ob-button type="primary" v-if="SignatureType == 1" @click="showElectronicsign">Initiate</ob-button>
             <ob-button type="primary" v-else @click="onMaterialChangeInitiated">{{ isupdate ? 'Update' : 'Initiate' }}</ob-button>
        </template>
    </ob-modal2>
        <div v-if="showElectronicSignPopUp">
            <electronic-sign-warning-pop-up :openModalWarning.sync = "showElectronicSignPopUp" :ConsentAvailable.sync = "consentAvailable" :ProceedtoInitiate.sync = "proceedtoInitiate" ></electronic-sign-warning-pop-up>
        </div>
    </div>
</template>
<script>
import WarningPopUp from "Vue/ESSProfile/FormI983/ElectronicSignWarningPopUp.vue"
import { required, minLength, maxLength, requiredIf, email, alpha, minValue } from 'vuelidate/lib/validators'
    import { req, withParams } from 'vuelidate/lib/validators/common'
      const DecimalNumber = withParams({ type: 'DecimalNumber' }, value => {
        return !req(value) || /^\d+(\.\d{1,2})?$/.test(value);
    })
     const alphawithspace = (value) => {
     var alsp = /^[a-zA-Z\s]*$/i
     return alsp.test(value)
   }
     const phoneNumber = (param) =>
    withParams(
        { type: 'phoneNumber', value: param},
        (value) => { 
            if(param && (param.indexOf("ChangeInEmployerSite") > -1)  || param.indexOf("Others") > -1) {
               if(value.length > 9 && value.length < 21)
               {
                var phone = /^[0-9 +()-]+$/i
                return phone.test(value)
               }
               else
               {
                 return false
               }
            } else {
                return true;
            }
        }
    );
    const letterCount = withParams({ type: 'letterCount' }, value => {
        if (value !=null && value.length <= 150) {
            var strArr = value.split(" ");
            let error = true;
            strArr.forEach(function (word) {
                if (word.length > 100) {
                    error = false
                    return;
                }
            });
            return !req(value) || error
        }
        else {
            return true
        }

    })

    const ValidSalaryType = (param) =>
        withParams(
            { type: 'ValidSalaryType', value: param},
            (value) => {
                if(param && (param.indexOf("ReductionInStudentCompensation") > -1 || param.indexOf("PeriodicEvaluationFromTheUniversity") > -1)  || param.indexOf("Others") > -1) {
                    return value != "None" && value != "";
                } else {
                    return true;
                }
            }
        );

    const ValidSalary = (param) =>
        withParams(
            { type: 'ValidSalary', value: param},
            (value) => {
                if(param && (param.indexOf("ReductionInStudentCompensation") > -1 || param.indexOf("PeriodicEvaluationFromTheUniversity") > -1)  || param.indexOf("Others") > -1) {
                    return value > 0;
                } else {
                    return true;
                }
            }
        );

    const ValidOPTHoursPerWeek = (param) =>
        withParams(
            { type: 'ValidOPTHoursPerWeek', value: param},
            (value) => {
                if(param && ((param.indexOf("ReductionInStudentCompensation") > -1) || param.indexOf("DecreaseInHoursPerweek") > -1) || param.indexOf("PeriodicEvaluationFromTheUniversity") > -1  || param.indexOf("Others") > -1){
                    return (value >= 20 && value <= 40);
                } else {
                    return true;
                }
            }
        );

    export default {
        props: ["openModal", "isupdate", "updatecontent","content"],
        components: {
            "electronic-sign-warning-pop-up": WarningPopUp
        },
        data(){
            return {
                showSignatoryauthorityList:false,
                showSA:false,
                trainingPlanSelectedSignatoryAuthorityEmail: '',
                IsInitiateOnlySectionType:true,
                signatoryauthorityList: {
                    placeholder: {
                        id: "-1",
                        text: "Select Signatory Authority"
                    },
                    data: []
                },
                    selectedSignatoryAuthorityEmail: '',
                    selectedSignatoryAuthority:'',
                show: '',
                MaterialChange:'',
                SignatureType: '',
                showSpecifyReason: false,
                SpecifyReason:'',
                EmployerInfo:
                {
                    EmployerIDNumber : '',
                    Salary : '',
                    SalaryType:'',
                    OPTHoursPerWeek : ''
                },
                Employer:{
                    SignatoryAuthority:{
                            SiteName: '',
                            SiteAddress: '',
                            Name: '',
                            Title: '',
                            Email: '',
                            Phone: '',
                            Role:''
                        
                    }
                },
                AssignedTraining:{
                    SignatoryAuthority:{
                            
                            Name: '',
                            Title: '',
                            Email: '',
                            Phone: '',
                           Role:''       
                    }

                },
                StudentDetails:
                {
                        SignatoryAuthoritySA: {
                            SiteName: '',
                            SiteAddress: '',
                            Name: '',
                            Title: '',
                            Email: '',
                            Phone: '',
                            Role:''
                        },
                            TrainingPlan:
                            {
                                Title:'',
                                StudentRole:'',
                                GoalsAndObjectives:'',
                                EmployerOversight:'',
                                MeasuresAndAssessments:'',
                                Remarks:''
                            },
                            Email: '',
                            SignatoryAuthority: {
                                TrainingName:'',
                                TrainingEmail:'',
                                TrainingTitle: '',
                                TrainingPhone: '',
                                Role:'',
                                SiteName: '',
                                SiteAddress: '',
                                Name: '',
                                Title: '',
                                Email: '',
                                Phone: ''
                            },
                    },
                materialChangeOptions:{
                    data: [
                        { id: "ChangeOfEmployerIdentificationNumber", text: 'Change of the employer’s Employer Identification Number (i.e., the company’s Federal Tax ID number)' },
                        { id: "ReductionInStudentCompensation", text: 'Reduction in student compensation that is not tied to a reduction in hours worked' },
                        { id: "DecreaseInHoursPerweek", text: 'Significant decrease in hours per week that a student engages in a STEM training opportunity' } ,
                        { id: "ChangesCommitmentsOrObjectives", text: 'Changes to the employer’s commitments or student’s learning objectives as documented on the Form I-983' },
                        { id: "PeriodicEvaluationFromTheUniversity", text: 'Periodic evaluation from  the University' },
                        { id:"ChangeInEmployerSite", text:"Change in employer site"},
                        { id: "Others" , text: 'Others'}
                    ],
                   placeholder: {
                    id: '-1',
                    text: 'Please select'
                },
                },
                showChangeOfEID: false,
                showReductionInComp: false,
                showdecreaseinHoursPerWeek: false,
                showChangetoTheEmployeeComm: false,
                showPeriodicEvaluationFromTheUniversity:false,
                showChangeInEmployerSite:false,

                 salary:{
                    data: [
                                {
                                    "id":"Hourly",
                                    "text":"Hourly"
                                },
                                {
                                    "id":"Weekly",
                                    "text":"Weekly"
                                },
                                {
                                    "id":"BiWeekly",
                                    "text":"Bi-Weekly"
                                },
                                {
                                    "id":"Monthly",
                                    "text":"Monthly"
                                },
                                {
                                    "id":"SemiMonthly",
                                    "text":"Semi-Monthly"
                                },
                                {
                                    "id":"Yearly",
                                    "text":"Yearly"
                                },
                            ],
                        placeholder: "Select Salary Frequency"
                    },
                showElectronicSignPopUp : false,
                proceedtoInitiate: false,
                consentAvailable: false,
            }
        },
        watch: {
            openModal(val) {
                this.show = val;
                if(val === true) { // Open Modal
                    this.copyFromStore();
                    this.getSignatoryauthorityList()
                }
            },
            
            show(val) {
                this.$emit('update:openModal', val)
            },
            selectedSignatoryAuthorityEmail(v) {
            this.onChangeSignatoryAuthority(v);
        },
            selectedSignatoryAuthority(v) {
            this.onChangeEmployerSignatoryAuthority(v);
        },
        trainingPlanSelectedSignatoryAuthorityEmail(v) {
            this.onChangetrainingPlanSignatoryAuthority(v);
        },
        proceedtoInitiate(val){
            debugger
                if(val && this.consentAvailable){
                    this.onMaterialChangeInitiated();
                }
            }
        },
        computed: {
            isSupervisor(){
                return true
            },
            IsInitiate(){
                return true
            },
            ShowEmployerSADropdownBasedOnMaterialChange() {
                if( this.MaterialChange == "") {
                    return true
                }else {
                    if (this.MaterialChange.includes("ReductionInStudentCompensation") || this.MaterialChange.includes("ChangeOfEmployerIdentificationNumber") || this.MaterialChange.includes("DecreaseInHoursPerweek") || this.MaterialChange.includes("PeriodicEvaluationFromTheUniversity") || this.MaterialChange.includes("Others")) {
                        return true;
                    }else {
                        return false
                    }
                }
            },
            ShowTrainingPlanSADropdownBasedOnMaterialChange() {
                
                if (this.MaterialChange.includes("ChangesCommitmentsOrObjectives") || this.MaterialChange.includes("PeriodicEvaluationFromTheUniversity") || this.MaterialChange.includes("ChangeInEmployerSite")) {
                    return true;
                }else {
                    return false
                }
            
        },
          EmployeeId() {
            return this.$parent.$parent.EmployeeId;
          },
          StudentName() {
            return this.$parent.$parent.StudentName;
          },
          onMaterialChange() {
            this.showSpecifyReason = false
            this.showChangeOfEID = false
            this.showReductionInComp = false
            this.showdecreaseinHoursPerWeek = false
            this.showChangetoTheEmployeeComm = false
            this.showPeriodicEvaluationFromTheUniversity = false
            this.showChangeInEmployerSite = false;

            if(this.MaterialChange)
            {
              for (var i = 0; i < this.MaterialChange.length; i++) {
                if(this.MaterialChange[i] == 'ChangeOfEmployerIdentificationNumber')
                {
                  this.showChangeOfEID = true
                }
                if(this.MaterialChange[i] == 'ReductionInStudentCompensation')
                {
                  this.showReductionInComp = true
                }
                if(this.MaterialChange[i] == 'DecreaseInHoursPerweek')
                {
                  this.showdecreaseinHoursPerWeek = true
                }
                if(this.MaterialChange[i] == 'ChangesCommitmentsOrObjectives')
                {
                  this.showChangetoTheEmployeeComm = true
                }
                if(this.MaterialChange[i] == 'PeriodicEvaluationFromTheUniversity')
                {
                  this.showPeriodicEvaluationFromTheUniversity = true
                }
                if(this.MaterialChange[i] == 'Others'){
                  this.showPeriodicEvaluationFromTheUniversity = true
                  this.showSpecifyReason = true
                }
                if(this.MaterialChange[i] == 'ChangeInEmployerSite')
                {
                    this.showChangeInEmployerSite = true;
                }
              }
            }
          }
        },
        created()
        {
           this.show = this.openModal
        },
        validations(){
          return{
            "trainingPlanSelectedSignatoryAuthorityEmail":{
                requiredIf: requiredIf(() => {
                                if(!this.isupdate && !this.IsInitiateOnlySectionType || this.ShowTrainingPlanSADropdownBasedOnMaterialChange) {
                                    return true
                                }else {
                                    return false
                                }
                            })
                        },
            "selectedSignatoryAuthorityEmail": {
                            requiredIf: requiredIf(() => {
                            if (this.MaterialChange.indexOf("ChangeInEmployerSite") > -1 || this.MaterialChange.indexOf("Others") > -1){
                            return true
                            } else {
                            return false
                            }
                                }),
            },
            "selectedSignatoryAuthority":{
                    requiredIf: requiredIf(() => {
                        if(!this.isupdate && this.ShowEmployerSADropdownBasedOnMaterialChange && !this.IsInitiateOnlySectionType ) {
                            return true
                        }else {
                            return false
                        }
                    })
                },
            MaterialChange:{
              required
            },
            SignatureType: {
                    requiredIf: requiredIf(() => {
                                        if(!this.isupdate) {
                                            return true
                                        }else {
                                            return false
                                        }
                                    })
                },
            "EmployerInfo":
            {
              "EmployerIDNumber":{
                requiredIf: requiredIf(()=>{
                  if (this.MaterialChange.indexOf("ChangeOfEmployerIdentificationNumber") > -1 || this.MaterialChange.indexOf("PeriodicEvaluationFromTheUniversity") > -1  || this.MaterialChange.indexOf("Others") > -1){
                    return true
                  }
                  else{
                    return false
                  }
                })
              },
              "Salary":{
                requiredIf: requiredIf(()=>{
                  if (this.MaterialChange.indexOf("ReductionInStudentCompensation") > -1 || this.MaterialChange.indexOf("PeriodicEvaluationFromTheUniversity") > -1  || this.MaterialChange.indexOf("Others") > -1){
                      return true
                    }
                    else{
                        return false
                    }
                  }),
                ValidSalary: ValidSalary(this.MaterialChange)
              },
              "SalaryType":{
                ValidSalaryType: ValidSalaryType(this.MaterialChange)
              },
              "OPTHoursPerWeek":{
                requiredIf: requiredIf(()=>{
                  if (this.MaterialChange.indexOf("ReductionInStudentCompensation") > -1 || this.MaterialChange.indexOf("DecreaseInHoursPerweek")> -1 || this.MaterialChange.indexOf("PeriodicEvaluationFromTheUniversity") > -1  || this.MaterialChange.indexOf("Others") > -1){
                    return true
                  }
                  else{
                      return false
                  }
                  }),
                ValidOPTHoursPerWeek: ValidOPTHoursPerWeek(this.MaterialChange)
              }
            },
            AssignedTraining:{
                "SignatoryAuthority": {
                    "Name": {
                                requiredIf: requiredIf(() => {
                                if(!this.isupdate && !this.IsInitiateOnlySectionType) {
                                    return true
                                }else {
                                    return false
                                }
                            }),
                            alphawithspace,
                            maxLength: maxLength(150),
                            letterCount
                        },
                            "Title": {
                                requiredIf: requiredIf(() => {
                                if(!this.isupdate && !this.IsInitiateOnlySectionType) {
                                    return true
                                }else {
                                    return false
                                }
                            }),
                            alphawithspace,
                            maxLength: maxLength(150),
                            letterCount
                        },
                        "Email": {
                                requiredIf: requiredIf(() => {
                                if(!this.isupdate && !this.IsInitiateOnlySectionType) {
                                    return true
                                }else {
                                    return false
                                }
                            }),
                            email
                        },
                        "Phone":{
                            requiredIf: requiredIf(() => {
                                if(!this.isupdate && !this.IsInitiateOnlySectionType) {
                                    return true
                                }else {
                                    return false
                                }
                            }),
                            phoneNumber : phoneNumber(this.MaterialChange),
                        },
                    },
            },
            Employer:{
                "SignatoryAuthority": {
                        "Name": {
                        requiredIf: requiredIf(() => {
                            if(!this.isupdate) {
                                            return true
                                        }else {
                                            return false
                                        }
                        }),
                        alphawithspace,
                        maxLength: maxLength(150),
                            letterCount
                        },
                        "Title": {
                        requiredIf: requiredIf(() => {
                            if(!this.isupdate) {
                                    return true
                                }else {
                                    return false
                                }
                        }),
                        alphawithspace,
                        maxLength: maxLength(150),
                            letterCount
                        },
                        "Email": {
                        requiredIf: requiredIf(() => {
                            if(!this.isupdate) {
                                            return true
                                        }else {
                                            return false
                                        }
                        }),
                        email
                        },
                        "Phone": {
                        requiredIf: requiredIf(() => {
                            if(!this.isupdate) {
                                            return true
                                        }else {
                                            return false
                                        }
                        }),
                        phoneNumber : phoneNumber(this.MaterialChange),
                        // maxLength: maxLength(20),
                        // minLength: minLength(10)
                        }, 
                        "SiteName": {
                                requiredIf: requiredIf(() => {
                                    if (this.MaterialChange.indexOf("ChangeInEmployerSite") > -1 || this.MaterialChange.indexOf("Others") > -1){
                                    return true
                                    } else {
                                    return false     }
                                }),
                                maxLength: maxLength(150),
                                letterCount
                        },
                        "SiteAddress": {
                        requiredIf: requiredIf(() => {
                            if (this.MaterialChange.indexOf("ChangeInEmployerSite") > -1 || this.MaterialChange.indexOf("Others") > -1){
                            return true
                            } else {
                            return false
                            }
                        }),
                        maxLength: maxLength(150),
                            letterCount
                        },
                    },
            },
            StudentDetails:
            {
                "SignatoryAuthoritySA": {   
                        "TrainingName": {
                        required,
                        // alphawithspace,
                        maxLength: maxLength(150),
                            letterCount
                        },
                    },
              "TrainingPlan":
              {
                "Title":{
                  requiredIf: requiredIf(()=>{
                    if (this.MaterialChange.indexOf("ChangesCommitmentsOrObjectives") > -1 || this.MaterialChange.indexOf("PeriodicEvaluationFromTheUniversity") > -1  || this.MaterialChange.indexOf("Others") > -1){
                      return true
                    }
                    else{
                      return false
                    }
                  })
                }
              },
              "SignatoryAuthority": {
                        "SiteName": {
                                requiredIf: requiredIf(() => {
                                    if (this.MaterialChange.indexOf("ChangeInEmployerSite") > -1 || this.MaterialChange.indexOf("Others") > -1){
                                    return true
                                    } else {
                                    return false     }
                                }),
                                maxLength: maxLength(150),
                                letterCount
                        },
                        "SiteAddress": {
                        requiredIf: requiredIf(() => {
                            if (this.MaterialChange.indexOf("ChangeInEmployerSite") > -1 || this.MaterialChange.indexOf("Others") > -1){
                            return true
                            } else {
                            return false
                            }
                        }),
                        maxLength: maxLength(150),
                            letterCount
                        },
                        "Name": {
                        requiredIf: requiredIf(() => {
                            if (this.MaterialChange.indexOf("ChangeInEmployerSite") > -1 || this.MaterialChange.indexOf("Others") > -1){
                            return true
                            } else {
                            return false
                            }
                        }),
                        alphawithspace,
                        maxLength: maxLength(150),
                            letterCount
                        },
                        "Title": {
                        requiredIf: requiredIf(() => {
                            if (this.MaterialChange.indexOf("ChangeInEmployerSite") > -1 || this.MaterialChange.indexOf("Others") > -1){
                            return true
                            } else {
                            return false
                            }
                        }),
                        alphawithspace,
                        maxLength: maxLength(150),
                            letterCount
                        },
                        "Email": {
                        requiredIf: requiredIf(() => {
                            if (this.MaterialChange.indexOf("ChangeInEmployerSite") > -1 || this.MaterialChange.indexOf("Others") > -1){
                            return true
                            } else {
                            return false
                            }
                        }),
                        email
                        },
                        "Phone": {
                        requiredIf: requiredIf(() => {
                            if (this.MaterialChange.indexOf("ChangeInEmployerSite") > -1 || this.MaterialChange.indexOf("Others") > -1){
                            return true
                            } else {
                            return false
                            }
                        }),
                        phoneNumber : phoneNumber(this.MaterialChange),
                       
                        },                        
                    },
            },
            SpecifyReason:{
              requiredIf: requiredIf(()=>{
                if (this.MaterialChange.indexOf("Others") > -1){
                    return true
                  }
                  else{
                    return false
                  }
                })
            }
          }
        },
        methods:{
            getSignatoryauthorityList()
            {
                this.showSA = false;
                 this.showSignatoryauthorityList = false
                ajax.get(`/I983/SignatoryList?employeeId=${this.EmployeeId}`,{},(res)=>{
                    this.signatoryauthorityList.data = __.map(res.data.SignatoryModelList, (t) => {
                        var name = t.BasicModel.Name;
                        if(t.Email == this.loggedInUserObj.email)
                        {
                          name = t.BasicModel.Name + "(you)";
                        }
                        return { 'id': t.Email, 'text': name, "title":t.Designation , "phone":t.Phone ,"Role":t.Role,"SAId":t.Id}
                    })
                    this.showSA = true;
                    this.selectedSignatoryAuthorityEmail = this.Employer.SignatoryAuthority.Email;
                    this.selectedSignatoryAuthority = this.Employer.SignatoryAuthority.Email;
                    this.showSignatoryauthorityList = true
                    this.$loading({ "loadingText": "Please wait.." }).close()
                 })
            },
            onChangetrainingPlanSignatoryAuthority(selectedSignatoryAuthorityEmail){
              if (selectedSignatoryAuthorityEmail) {
                  const selectedAuthority = this.signatoryauthorityList.data.find(x => x.id === selectedSignatoryAuthorityEmail);
                    if (selectedAuthority) {
                      this.AssignedTraining.SignatoryAuthority.Name = selectedAuthority.text.replace(/\s?\(you\)\s*$/, '').trim();;
                      this.AssignedTraining.SignatoryAuthority.Email = selectedAuthority.id;
                      this.AssignedTraining.SignatoryAuthority.Title = selectedAuthority.title;
                      this.AssignedTraining.SignatoryAuthority.Phone = selectedAuthority.phone;
                      this.AssignedTraining.SignatoryAuthority.Role = selectedAuthority.Role;
                      this.AssignedTraining.SignatoryAuthority.Id = selectedAuthority.SAId;


                    }
              }
            },
            onChangeEmployerSignatoryAuthority(selectedSignatoryAuthorityEmail){
                if (selectedSignatoryAuthorityEmail) {
                    const selectedAuthority = this.signatoryauthorityList.data.find(x => x.id === selectedSignatoryAuthorityEmail);
                    if (selectedAuthority) {
                      this.Employer.SignatoryAuthority.Name = selectedAuthority.text.replace(/\s?\(you\)\s*$/, '').trim();;
                      this.Employer.SignatoryAuthority.Email = selectedAuthority.id;
                      this.Employer.SignatoryAuthority.Title = selectedAuthority.title;
                      this.Employer.SignatoryAuthority.Phone = selectedAuthority.phone;
                      this.Employer.SignatoryAuthority.Role = selectedAuthority.Role;
                      this.Employer.SignatoryAuthority.Id = selectedAuthority.SAId;

                    }
                }
            },
            onChangeSignatoryAuthority(selectedSignatoryAuthorityEmail){
                
              if (selectedSignatoryAuthorityEmail) {
                  const selectedAuthority = this.signatoryauthorityList.data.find(x => x.id === selectedSignatoryAuthorityEmail);
                    if (selectedAuthority) {
                      this.Employer.SignatoryAuthority.Name = selectedAuthority.text.replace(/\s?\(you\)\s*$/, '').trim();
                      this.Employer.SignatoryAuthority.Email = selectedAuthority.id;
                      this.Employer.SignatoryAuthority.Title = selectedAuthority.title;
                      this.Employer.SignatoryAuthority.Phone = selectedAuthority.phone;
                      this.Employer.SignatoryAuthority.Role = selectedAuthority.Role;
                      this.Employer.SignatoryAuthority.Id = selectedAuthority.SAId;

                    }
              }
            },
            handleCancel() {
                this.show = false
                this.SignatureType = ''
                this.$v.SignatureType.$reset();
                this.trainingPlanSelectedSignatoryAuthorityEmail = ''
                this.selectedSignatoryAuthority = ''
                this.$v.trainingPlanSelectedSignatoryAuthorityEmail.$reset()
                this.$v.selectedSignatoryAuthority.$reset()
                this.$v.Employer.SignatoryAuthority.$reset()
                this.$v.AssignedTraining.SignatoryAuthority.$reset()
                
            },
             getSupervisorDetails()
                {
                    ajax.get(`/I983/GetSupervisorDetails?EmployeeId=${this.EmployeeId}&ConsultantId=${this.loggedInUserObj.consultantId}`, {}, (res) => {
                        if(res.data.State == true && res.data.EmployeeDetail != null && res.data.EmployeeDetail.EmailId != null) {
                        var address1 = res.data.EmployeeDetail.Address.Address1 != null && res.data.EmployeeDetail.Address.Address1 != '' ? res.data.EmployeeDetail.Address.Address1 + "," : '';
                        var street = res.data.EmployeeDetail.Address.StreetNo != null && res.data.EmployeeDetail.Address.StreetNo != '' ? res.data.EmployeeDetail.Address.StreetNo + "," : '';
                        var city = res.data.EmployeeDetail.Address.City != null && res.data.EmployeeDetail.Address.City != '' ? res.data.EmployeeDetail.Address.City + "," : '';
                        var state = res.data.EmployeeDetail.Address.State != null && res.data.EmployeeDetail.Address.State != '' ? res.data.EmployeeDetail.Address.State + "," : '';
                        var zip = res.data.EmployeeDetail.Address.ZipCode != null && res.data.EmployeeDetail.Address.ZipCode != '' ? res.data.EmployeeDetail.Address.ZipCode : '';
                        var address = address1 + street + city + state + zip
                        var name = res.data.EmployeeDetail.FirstName+" "+res.data.EmployeeDetail.LastName
                        var designation = res.data.EmployeeDetail.Designation;

                        var signatoryAuthority = {
                            SiteName: res.data.EmployeeDetail.ClientOrganizationName != '' && res.data.EmployeeDetail.ClientOrganizationName != null ? res.data.EmployeeDetail.ClientOrganizationName : res.data.EmployeeDetail.OrganizationName,
                            SiteAddress: address ,
                            Name: this.updatecontent.Employer.SignatoryAuthority.Name,
                            Title: this.updatecontent.Employer.SignatoryAuthority.Title,
                            Email: this.updatecontent.Employer.SignatoryAuthority.Email,
                            Phone: this.updatecontent.Employer.SignatoryAuthority.Phone,
                            }
                            this.StudentDetails.SignatoryAuthority = signatoryAuthority
                            this.Employer.SignatoryAuthority = signatoryAuthority
                        }
                        else{
                        var signatoryAuthority = {
                            SiteName: this.loggedInUserObj.OrgName,
                            SiteAddress: this.loggedInUserObj.OrgAddress ,
                            Name: this.loggedInUserObj.Name,
                            Title: this.loggedInUserObj.Role,
                            Email: this.loggedInUserObj.Email,
                            Phone: '',
                            }
                            this.StudentDetails.SignatoryAuthority = signatoryAuthority
                            this.Employer.SignatoryAuthority = signatoryAuthority
                        }
                    })
            },
            resetData() {
                // Reset Data
                this.MaterialChange = '';
                this.SpecifyReason = '';
                this.EmployerInfo = {
                    EmployerIDNumber : '',
                    Salary : '',
                    SalaryType:'',
                    OPTHoursPerWeek : ''
                };
                this.Employer={
                    SignatoryAuthority:{
                            SiteName: '',
                            SiteAddress: '',
                            Name: '',
                            Title: '',
                            Email: '',
                            Phone: '',
                            Role:''
                        
                    }
                },
                this.AssignedTraining={
                    SignatoryAuthority:{
                            Name: '',
                            Title: '',
                            Email: '',
                            Phone: '',
                           Role:''       
                    }

                },
                this.StudentDetails = {
                    TrainingPlan:
                    {
                        Title:'',
                        StudentRole:'',
                        GoalsAndObjectives:'',
                        EmployerOversight:'',
                        MeasuresAndAssessments:'',
                        Remarks:''
                    },
                     SignatoryAuthority: {
                        TrainingName:'',
                     TrainingEmail:'',
                     TrainingTitle:'',
                     TrainingPhone:'',
                        SiteName: '',
                        SiteAddress: '',
                        Name: '',
                        Title: '',
                        Email: '',
                        Phone: ''
                    },
                    TrainingSupervisor:{
                     TrainingName:'',
                     TrainingEmail:'',
                     TrainingTitle:'',
                     TrainingPhone:''
                    },
                    SignatoryAuthoritySA: {
                            SiteName: '',
                            SiteAddress: '',
                            Name: '',
                            Title: '',
                            Email: '',
                            Phone: ''
                        },
                };

                this.showChangeOfEID = false
                this.showReductionInComp = false
                this.showdecreaseinHoursPerWeek = false
                this.showChangetoTheEmployeeComm = false
                this.PeriodicEvaluationFromTheUniversity = false
                this.showSpecifyReason = false

                // Reset Validations
                this.$v.StudentDetails.$reset();
                this.$v.EmployerInfo.$reset();
                this.$v.MaterialChange.$reset();
                this.$v.SpecifyReason.$reset();

            },
            copyFromStore() {
                this.resetData();
                 
                if(this.isupdate == true) { // When update copy the values MaterialChange Object
                    this.MaterialChange = this.updatecontent.MaterialChange.MaterialChangeType;
                    this.SpecifyReason = this.updatecontent.MaterialChange.SpecifyReason;

                    this.EmployerInfo.EmployerIDNumber = this.updatecontent.MaterialChange.EIN;
                    this.EmployerInfo.OPTHoursPerWeek = this.updatecontent.MaterialChange.OPTHours;
                    this.EmployerInfo.Salary = this.updatecontent.MaterialChange.Salary;
                    this.EmployerInfo.SalaryType = this.updatecontent.MaterialChange.SalaryFrequency;

                    this.StudentDetails.TrainingPlan.Title = this.updatecontent.MaterialChange.Training.Title;
                    this.StudentDetails.TrainingPlan.StudentRole = this.updatecontent.MaterialChange.Training.StudentRole;
                    this.StudentDetails.TrainingPlan.GoalsAndObjectives = this.updatecontent.MaterialChange.Training.Objectives;
                    this.StudentDetails.TrainingPlan.EmployerOversight = this.updatecontent.MaterialChange.Training.EmployerOverSight;
                    this.StudentDetails.TrainingPlan.MeasuresAndAssessments = this.updatecontent.MaterialChange.Training.Assessments;
                    this.StudentDetails.TrainingPlan.Remarks = this.updatecontent.MaterialChange.Training.AdditionalRemarks;
                } else {
                    this.EmployerInfo.EmployerIDNumber = this.updatecontent.Employer.EIN;
                    this.EmployerInfo.OPTHoursPerWeek = this.updatecontent.Employer.OPTHours;
                    this.EmployerInfo.Salary = this.updatecontent.Employer.Salary;
                    this.EmployerInfo.SalaryType = this.updatecontent.Employer.SalaryFrequency;

                    this.StudentDetails.TrainingPlan.Title = this.updatecontent.AssignedTraining.Training.Title;
                    this.StudentDetails.TrainingPlan.StudentRole = this.updatecontent.AssignedTraining.Training.StudentRole;
                    this.StudentDetails.TrainingPlan.GoalsAndObjectives = this.updatecontent.AssignedTraining.Training.Objectives;
                    this.StudentDetails.TrainingPlan.EmployerOversight = this.updatecontent.AssignedTraining.Training.EmployerOverSight;
                    this.StudentDetails.TrainingPlan.MeasuresAndAssessments = this.updatecontent.AssignedTraining.Training.Assessments;
                    this.StudentDetails.TrainingPlan.Remarks = this.updatecontent.AssignedTraining.Training.AdditionalRemarks;
                }
                // if(this.updatecontent.AssignedTraining.SignatoryAuthority != null)
                // {
                
                    this.Employer.SignatoryAuthority.SiteName = this.content.AssignedTraining.SiteName;
                    this.Employer.SignatoryAuthority.SiteAddress = this.content.AssignedTraining.SiteAddress;
                    this.Employer.SignatoryAuthority.Name = this.content.Employer.SignatoryAuthority.Name;
                    this.Employer.SignatoryAuthority.Title = this.content.Employer.SignatoryAuthority.Title;
                    this.Employer.SignatoryAuthority.Email = this.content.Employer.SignatoryAuthority.Email;
                    this.Employer.SignatoryAuthority.Phone = this.content.Employer.SignatoryAuthority.Phone;
                    this.trainingPlanSelectedSignatoryAuthorityEmail = this.content.AssignedTraining.SignatoryAuthority.Email;

                    this.AssignedTraining.SignatoryAuthority.Name = this.content.AssignedTraining.SignatoryAuthority.Name;
                    this.AssignedTraining.SignatoryAuthority.Title = this.content.AssignedTraining.SignatoryAuthority.Title;
                    this.AssignedTraining.SignatoryAuthority.Email = this.content.AssignedTraining.SignatoryAuthority.Email;
                    this.AssignedTraining.SignatoryAuthority.Phone = this.content.AssignedTraining.SignatoryAuthority.Phone;

                this.IsInitiateOnlySectionType = true;
            },
            copyToStore() {
                // let obj = {
                //     MaterialChange: {
                //         Training: {}
                //     },
                //     Employer:
                //     {
                //         SignatoryAuthority:{},
                //         SignatoryAuthority:{},
                    
                //     }
                // };

                // obj.MaterialChange.MaterialChangeType = this.MaterialChange;
                // obj.MaterialChange.SpecifyReason = this.SpecifyReason;
                // obj.MaterialChange.ModifiedLogs = this.updatecontent.MaterialChange.ModifiedLogs;

                // obj.MaterialChange.EIN = this.EmployerInfo.EmployerIDNumber;
                // obj.MaterialChange.OPTHours = this.EmployerInfo.OPTHoursPerWeek;
                // obj.MaterialChange.Salary = this.EmployerInfo.Salary;
                // obj.MaterialChange.SalaryFrequency = this.EmployerInfo.SalaryType;

                // obj.MaterialChange.Training.Title = this.StudentDetails.TrainingPlan.Title;
                // obj.MaterialChange.Training.StudentRole = this.StudentDetails.TrainingPlan.StudentRole;
                // obj.MaterialChange.Training.Objectives = this.StudentDetails.TrainingPlan.GoalsAndObjectives;
                // obj.MaterialChange.Training.EmployerOverSight = this.StudentDetails.TrainingPlan.EmployerOversight;
                // obj.MaterialChange.Training.Assessments = this.StudentDetails.TrainingPlan.MeasuresAndAssessments;
                // obj.MaterialChange.Training.AdditionalRemarks = this.StudentDetails.TrainingPlan.Remarks;

                // obj.Employer.Supervisor.SiteName = this.Employer.SignatoryAuthority.SiteName;
                // obj.Employer.Supervisor.SiteAddress = this.Employer.SignatoryAuthority.SiteAddress;
                // obj.Employer.SignatoryAuthority.Name = this.Employer.SignatoryAuthority.Name;
                // obj.Employer.SignatoryAuthority.Title = this.Employer.SignatoryAuthority.Title;
                // obj.Employer.SignatoryAuthority.Email = this.Employer.SignatoryAuthority.Email;
                // obj.Employer.SignatoryAuthority.Phone = this.Employer.SignatoryAuthority.Phone;
                // // obj.Employer.TrainingSupervisor.TrainingName = this.StudentDetails.SignatoryAuthority.TrainingName;
                // // obj.Employer.TrainingSupervisor.TrainingTitle = this.StudentDetails.SignatoryAuthority.TrainingTitle;
                // // obj.Employer.TrainingSupervisor.TrainingEmail = this.StudentDetails.SignatoryAuthority.TrainingEmail;
                // // obj.Employer.TrainingSupervisor.TrainingPhone = this.StudentDetails.SignatoryAuthority.TrainingPhone;
               

                // this.$emit('update:updatecontent', obj);

                window.bus.fire('SendI983RefreshSignal', '');


            },
            onMaterialChangeInitiated() {

                this.$v.Employer.$touch();
                this.$v.AssignedTraining.$touch();
                this.$v.EmployerInfo.$touch();
                this.$v.MaterialChange.$touch();
                this.$v.SpecifyReason.$touch();
                this.$v.SignatureType.$touch();
                this.$v.trainingPlanSelectedSignatoryAuthorityEmail.$touch();
                
                if(this.$v.Employer.$invalid == false && this.$v.EmployerInfo.$invalid == false && this.$v.MaterialChange.$invalid == false && this.$v.SpecifyReason.$invalid == false && !this.$v.SignatureType.$invalid &&  !this.$v.AssignedTraining.$invalid)
                {
                    this.show = false;
                     var signatoryAuthority = {
                        Name: this.Employer.SignatoryAuthority.Name && this.Employer.SignatoryAuthority.Name.includes("(you)") ? this.Employer.SignatoryAuthority.Name.replace("(you)", "").trim() : this.Employer.SignatoryAuthority.Name,
                        Title: this.Employer.SignatoryAuthority.Title == 'HRManager' ? 'HR Manager': this.Employer.SignatoryAuthority.Title,
                        Email: this.Employer.SignatoryAuthority.Email,
                        Phone: this.Employer.SignatoryAuthority.Phone ?this.Employer.SignatoryAuthority.Phone:this.AssignedTraining.SignatoryAuthority.Phone,
                        Role:this.Employer.SignatoryAuthority.Role
                    };
                    // var Trainingsupervisor = {
                    // Name: this.StudentDetails.SignatoryAuthority.TrainingName,
                    // Title: this.StudentDetails.SignatoryAuthority.TrainingTitle,
                    // Email: this.StudentDetails.SignatoryAuthority.TrainingEmail,
                    // };


                    var employee = {
                        EmployeeId : !this.$parent.$parent.isSupervisor ? this.EmployeeId : this.$parent.$parent.EmployeeId,
                        Name: this.StudentName
                    }
                    var employer = {
                        EIN:this.EmployerInfo.EmployerIDNumber,
                        OPTHours:this.EmployerInfo.OPTHoursPerWeek,
                        Salary:this.EmployerInfo.Salary,
                        SalaryFrequency:this.EmployerInfo.SalaryType,
                        SignatoryAuthority: signatoryAuthority,
                        // TrainingSupervisor:Trainingsupervisor

                    }
                    var trainingPlan = {
                        Title:this.StudentDetails.TrainingPlan.Title,
                        StudentRole:this.StudentDetails.TrainingPlan.StudentRole,
                        Objectives:this.StudentDetails.TrainingPlan.GoalsAndObjectives,
                        EmployerOverSight:this.StudentDetails.TrainingPlan.EmployerOversight,
                        Assessments:this.StudentDetails.TrainingPlan.MeasuresAndAssessments,
                        AdditionalRemarks:this.StudentDetails.TrainingPlan.Remarks
                    }
                    var TrainingSignatoryAuthority = {
                        Name: this.AssignedTraining.SignatoryAuthority.Name && this.AssignedTraining.SignatoryAuthority.Name.includes("(you)") ? this.AssignedTraining.SignatoryAuthority.Name.replace("(you)", "").trim() : this.AssignedTraining.SignatoryAuthority.Name,
                        Title: this.AssignedTraining.SignatoryAuthority.Title == 'HRManager' ? 'HR Manager': this.AssignedTraining.SignatoryAuthority.Title,
                        Email: this.AssignedTraining.SignatoryAuthority.Email,
                        Phone: this.AssignedTraining.SignatoryAuthority.Phone?this.AssignedTraining.SignatoryAuthority.Phone:this.Employer.SignatoryAuthority.Phone,
                        Role:this.AssignedTraining.SignatoryAuthority.Role,
                        Id:this.AssignedTraining.SignatoryAuthority.Id

                    };
                    var assignedTraining = {
                        Training:trainingPlan,
                        SignatoryAuthority:TrainingSignatoryAuthority,
                        SiteName: this.Employer.SignatoryAuthority.SiteName,
                        SiteAddress: this.Employer.SignatoryAuthority.SiteAddress,

                    }
                    var materialChange = {
                        MaterialChangeType : this.MaterialChange,
                        SpecifyReason : this.SpecifyReason
                    }
                    let obj =
                    {
                        Employee : employee,
                        Employer : employer,
                        MaterialChange:materialChange,
                        AssignedTraining:assignedTraining,
                        Type :  "MaterialChange",
                        IsInitiateOnlySectionType:this.IsInitiateOnlySectionType,
                        SignatureType: this.SignatureType,
                    }

                    if(this.isupdate == true) {
                        this.makeUpdateAPICall(obj);
                    } else {
                        this.makeInitiateAPICall(obj);
                    }
                }
                this.proceedtoInitiate =false
            },
            makeInitiateAPICall(obj) {
                this.$loading({'loadingText': 'Initiating Material Change...'});
                ajax.post(`/I983/Initiate?empOrgId=${loggedInUserObj.orgId}`,obj, (res) => {
                    if(res.data.State == true){
                        this.$message({
                            type: 'success',
                            message: 'Material Change initiated successfully'
                        });
                        this.$loading({}).close()
                        this.show = false
                        this.$emit('initiated');
                    }else if(res.data.State == false){
                        this.$loading({}).close()
                        this.show = false
                        this.ESSEnableDisable(res)
                        this.$message({
                            type: 'error',
                            message: res.data.Message
                        });
                    }
                });
            },
            makeUpdateAPICall(obj) {
                this.$loading({'loadingText': 'Updating Material Change...'});
                ajax.put(`/I983/${this.updatecontent.Id}/UpdateMaterialChange`,obj, (res) => {
                    if(res.data.State == true){
                        this.$message({
                            type: 'success',
                            message: 'Material Change updated successfully'
                        });
                        this.$loading({}).close()
                        this.show = false;
                        this.copyToStore();
                        this.$parent.$parent.insertModifiedLogToStore('MaterialChange');
                    }else if(res.data.State == false){
                        this.$loading({}).close()
                        this.show = false
                        this.ESSEnableDisable(res)
                        this.$message({
                            type: 'error',
                            message: res.data.Message
                        });
                    }
                });
            },
              showElectronicsign(){
                this.showElectronicSignPopUp = true;
            }
        }
    }
</script>
<style lang="scss" scoped>
   .title-content
   {
       color: #4a90e2;
       font-size: 14px;
   }
    .note-content
    {
        color: #4a90e2;
        font-weight: 600;
        font-size: 13px;
    }
   .rowgap
   {
       margin-top: 10px;
   }
   .validation-star{
            color: #F31D1D;
    }
    .radio-inline
    {
        padding-left: 0px
    }
    label{

         color :#a4abb9
    }
    .preview-details {
		padding: 10px 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/FormI983/InitiateMaterialChangePopup.vue